import { useRef, useState } from 'react';

import type { FigmaBreakpoint } from '../../figma/useFigmaBreakpoint';
import { Stars, type StarsRating } from '../Stars/Stars';
import './video-card.css';

export interface VideoCardProps {
  rating: StarsRating;
  size: FigmaBreakpoint;
  title: string;
  videoUrl: string;
}

const FIGMA_NODES: Record<FigmaBreakpoint, string> = {
  '1920': '26:11423',
  '1440': '26:11423',
  '768': '125:47231',
  '375': '125:48085',
};

export function VideoCard({ rating, size, title, videoUrl }: VideoCardProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);

  async function togglePlayback() {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) await video.play();
    else video.pause();
  }

  return (
    <article
      className={`lovo-video-card lovo-video-card--${size}`}
      data-figma-node={FIGMA_NODES[size]}
      data-figma-variant={`Size=${size === '1440' ? '1920+1440' : size}`}
    >
      <header>
        <Stars className="lovo-video-card__stars" mode="Light" rating={rating} />
        <h3>{title}</h3>
      </header>
      <div className="lovo-video-card__media">
        <video
          onPause={() => setPlaying(false)}
          onPlay={() => setPlaying(true)}
          playsInline
          preload="metadata"
          ref={videoRef}
          src={videoUrl}
        />
        {!playing && (
          <button aria-label="Воспроизвести видеоотзыв" onClick={togglePlayback} type="button">
            <img src="/figma/assets/review-play.svg" alt="" aria-hidden="true" />
          </button>
        )}
      </div>
    </article>
  );
}
